import React from 'react'

// Components
import News from 'components/flex/Posts/News'
import BlogSmall from 'components/flex/Posts/BlogSmall'
import ProductSmall from 'components/flex/Posts/ProductSmall'
import ProductPortfolio from 'components/flex/Posts/ProductPortfolio'
import NewsOther from 'components/flex/Posts/NewsOther'
import Vacancies from 'components/flex/Posts/Vacancies'
import Partners from 'components/flex/Posts/Partners'

interface PostsShellProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_PostTypes
  location?: any
}

interface PostProps {
  [key: string]: any
}

const PostsShell: React.FC<PostsShellProps> = ({ fields, location = {} }) => {
  const types: PostProps = {
    news: News,
    previewblog: BlogSmall,
    othernews: NewsOther,
    previewproducts: ProductSmall,
    portfolioproducts: ProductPortfolio,
    vacancies: Vacancies,
    partners: Partners,
  }

  if (!fields.styletype || !types[fields.styletype]) {
    return null
  }

  const Component = types[fields.styletype]

  return (
    <Component
      key={`${location ? location.pathname : 'flex'}`}
      fields={fields}
      location={location}
    />
  )
}

export default PostsShell
